export const useGetTermsName = () => {
  const singularTermsName = 'Brief';
  const pluralTermsName = 'Briefs';
  return {
    singularTermsName,
    pluralTermsName,
  };
};
